import React, { useCallback, useState } from 'react'
import { ReactComponent as EditIcon } from 'assets/icons/Edit.svg';
import { ReactComponent as ArchivesIcon } from 'assets/icons/Archives.svg';
import { ReactComponent as TrashIcon } from 'assets/icons/Trash.svg';
import { NewsletterStyles } from './Style'
import { currentDateTime, customFormatDate, formatDateTime } from 'utils/formatter'
import { Img, LightButton, ScreenStyles } from 'styles/GlobalStyle'
import { IconButton, SvgIcon } from '@mui/material'
import { Add } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom';
import { app } from 'router/routes';
import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryClient as qc } from 'keys'
import { editNewsletterFetch, getNewsletterFetch, removeNewsletterFetch } from 'store/middlewares/newsletter.crud';
import { Placeholder } from 'assets'
import { Can } from 'components/Permissions';
import { NewsletterActionAlert } from '.';
import { Title as ScreenTitle } from 'components'

const Newsletter = React.memo((props) => {
    const { feature, title } = props
    const navigate = useNavigate()
    const [openTrashAlert, setOpenTrashAlert] = useState(false)
    const [openArchivedAlert, setOpenArchivedAlert] = useState(false)
    const [currentId, setCurrentId] = useState(null)

    const newletterOptions = queryOptions({
        queryKey: [qc.newsletters],
        queryFn: async () => {
            const { data } = await getNewsletterFetch()
            return data
        },
        refetchOnWindowFocus: false
    })
    const newsletters = useQuery(newletterOptions)

    const goCreateNewsletter = useCallback(() => navigate(app.createNewsletter), [])
    const goNewsletter = useCallback((id) => {
        navigate(`${app.newsletters}/${id}/edit/`)
    }, [])
    const goViewNewsletter = useCallback((id) => navigate(`${app.newsletters}/${id}/`), [])

    return (
        <ScreenStyles>
            <NewsletterStyles>
                <div className='newsletter-header'>
                    <LightButton variant="solid" size="small" label="הוספת עדכון" icon={<Add fontSize='small' />} action={goCreateNewsletter} />
                </div>
                <div className='newsletter-list'>
                    {newsletters.data?.map((post, index) => {
                        const { name, description, image, id, title, area, official_release_date } = post
                        return (
                            <div className='news-card' key={index} onClick={() => goViewNewsletter(id)}>
                                <div className='news-header'>
                                    <div>
                                        <div className='news-date'>{customFormatDate(official_release_date)}</div>
                                        <div className='news-name'>{`${name}${area ? `/ ${area}` : ""}`}</div>
                                    </div>
                                    <div>
                                        <Can I="manage" a="super-user">
                                            <IconButton onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                setCurrentId(id)
                                                setOpenArchivedAlert(true)
                                            }}>
                                                <SvgIcon fontSize="small" component={ArchivesIcon} inheritViewBox />
                                            </IconButton>
                                            <IconButton onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                setCurrentId(id)
                                                setOpenTrashAlert(true)
                                            }}>
                                                <SvgIcon fontSize="small" component={TrashIcon} inheritViewBox />
                                            </IconButton>
                                            <IconButton onClick={(e) => {
                                                e.preventDefault()
                                                e.stopPropagation()
                                                goNewsletter(id)
                                            }}>
                                                <SvgIcon fontSize="small" component={EditIcon} inheritViewBox />
                                            </IconButton>
                                        </Can>
                                    </div>
                                </div>
                                <div className='news-content'>
                                    <div className='news-title'>{title}</div>
                                    <div className='news-description'>
                                        {!description || description}
                                    </div>
                                    <div className='news-footer'>
                                        <div className='news-image'>
                                            {<Img src={image || Placeholder} />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
                {openArchivedAlert && <NewsletterActionAlert id={currentId} type="archived" handleAlert={setOpenArchivedAlert} />}
                {openTrashAlert && <NewsletterActionAlert id={currentId} type="trash" handleAlert={setOpenTrashAlert} />}
            </NewsletterStyles>
        </ScreenStyles>
    )
}, () => { })

export default Newsletter